var render = function () {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid", attrs: { id: "await-reply" } },
    [
      _c("a-table", {
        key: "vtable-" + _vm.renderCount,
        staticClass: "custom-table2",
        attrs: {
          columns: _vm.columns(),
          dataSource: _vm.getWaitingOfflineSupportRequests,
          locale: {
            emptyText: _vm.$t("message.noVisitorFound"),
          },
          pagination: false,
          rowKey: "_id",
          size: "small",
        },
        on: { change: _vm.tableChange },
        scopedSlots: _vm._u([
          {
            key: "_createdDate",
            fn: function (fullname, item) {
              return _c("div", {}, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm._f("date")(item.createdDate)) +
                    "\n        "
                ),
              ])
            },
          },
          {
            key: "_messageSlot",
            fn: function (fullname, item) {
              return _c("div", {}, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      (item.message || "").length > 100
                        ? _vm._.take(item.message || "", 100)
                            .concat("...")
                            .join("")
                        : item.message || ""
                    ) +
                    "\n        "
                ),
              ])
            },
          },
          {
            key: "_actions",
            fn: function (fullname, item) {
              return _c("div", {}, [
                _c(
                  "div",
                  { staticClass: "d-flex w-100 justify-content-start" },
                  [
                    _c(
                      "a-button",
                      {
                        staticClass: "actionButton d-flex align-items-center",
                        on: {
                          click: function ($event) {
                            return _vm.view(item._id, item.index)
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "margin-right": "16px",
                              display: "block",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("message.sendResponse")))]
                        ),
                        _vm._v(" "),
                        _c("ActionEdit"),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a-button",
                      {
                        staticClass: "actionButton d-flex align-items-center",
                        on: {
                          click: function ($event) {
                            return _vm.deleteRequest(item._id, item.index)
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "margin-right": "16px",
                              display: "block",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("message.delete")))]
                        ),
                        _vm._v(" "),
                        _c("ActionDelete"),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ])
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex justify-content-end align-items-center mt-3" },
        [
          _c(
            "a-button",
            {
              staticClass: "mr-3",
              attrs: { loading: _vm.loading, size: "small", type: "primary" },
              on: { click: _vm.fetchData },
            },
            [
              _vm.loading
                ? _c("div", [_vm._v(_vm._s(_vm.$t("message.loading")))])
                : _c(
                    "div",
                    [
                      _c("a-icon", { attrs: { type: "sync" } }),
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("message.refresh")) +
                          "\n            "
                      ),
                    ],
                    1
                  ),
            ]
          ),
          _vm._v(" "),
          _c("Pagination", {
            attrs: {
              "page-change": _vm.pageChange,
              "page-sizes": _vm.pageSizes,
              total: _vm.waitings.total,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "responseForm",
            title: _vm.$t("message.responseForm"),
            centered: "",
            "hide-footer": "",
            size: "lg",
          },
          on: { hidden: _vm.reset },
        },
        [
          _vm.viewingItem
            ? _c(
                "b-form",
                {
                  staticClass: "d-flex flex-column justify-content-end",
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.submit.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "12" } },
                        [
                          _c(
                            "a-descriptions",
                            {
                              attrs: {
                                title: _vm.$t("message.clientRequestInfo"),
                                bordered: "",
                              },
                            },
                            [
                              _c(
                                "a-descriptions-item",
                                {
                                  attrs: {
                                    label: _vm.$t("message.status"),
                                    span: 3,
                                  },
                                },
                                [
                                  _c("a-badge", {
                                    attrs: {
                                      text: _vm.$t(
                                        "message." + _vm.viewingItem.status
                                      ),
                                      status: "processing",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "a-descriptions-item",
                                {
                                  attrs: {
                                    label: _vm.$t("message.fullName"),
                                    span: 2,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.viewingItem.fullname) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a-descriptions-item",
                                {
                                  attrs: {
                                    label: _vm.$t("message.createdDate"),
                                    span: 2,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm
                                          .moment(_vm.viewingItem.createdDate)
                                          .format("DD/MM/YY HH:mm")
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a-descriptions-item",
                                {
                                  attrs: {
                                    label: _vm.$t("message.email"),
                                    span: 3,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.viewingItem.email) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a-descriptions-item",
                                {
                                  attrs: {
                                    label: _vm.$t("message.phone"),
                                    span: 3,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.viewingItem.phone) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a-descriptions-item",
                                {
                                  attrs: {
                                    label: _vm.$t("message.descMessage"),
                                    span: 3,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.viewingItem.message) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { md: "12 mt-2" } },
                        [
                          _c("ckeditor", {
                            key: "ckeditor-" + _vm.$i18n.locale,
                            ref: "`ckeditor`",
                            staticClass: "border-0 w-100",
                            staticStyle: { height: "300px" },
                            attrs: {
                              id: "response-editor",
                              config: _vm.editorConfig(),
                              editor: _vm.editor,
                              "tag-name": "textarea",
                            },
                            model: {
                              value: _vm.response,
                              callback: function ($$v) {
                                _vm.response = $$v
                              },
                              expression: "response",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-2" },
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "12" } },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "float-right",
                              attrs: {
                                disabled: _vm.responseSending,
                                type: "submit",
                                variant: "primary",
                              },
                            },
                            [
                              !_vm.responseSending
                                ? [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.$t("message.send")) +
                                        "\n                        "
                                    ),
                                  ]
                                : [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "spinner", spin: "" },
                                    }),
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.$t("message.sending")) +
                                        "...\n                        "
                                    ),
                                  ],
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "float-right mr-2",
                              on: {
                                click: function () {
                                  return this$1.$bvModal.hide("responseForm")
                                },
                              },
                            },
                            [
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.$t("message.cancel")) +
                                    "\n                        "
                                ),
                              ],
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }